import { Avatar, JiraLogo } from "src/assets/svgs";

import LinkButton from "src/components/icom-link-btn";

const LinksComponent: React.FC = () => {
  return (
    <div className="links-screen p-8 pt-4 gap-8 flex flex-col" data-testid="initial-screen">
      <div className="dark:bg-neutral-gray-800 items-center bg-neutral-gray-5 text-white px-6 py-8 rounded-md">
        <h1 className="text-neutral-gray-900 dark:text-neutral-gray-50 text-2xl font-bold leading-6 font-sora mb-4">Links Úteis</h1>
        <div className="flex gap-6 pt-6 flex-wrap">
          <LinkButton Icon={JiraLogo} link="https://icom.app/tils" text="Pré chamado" />
          <LinkButton Icon={Avatar} link="https://www.rhsuite.com.br/ame/ame/login" text="RH Suite" />
          {/*  <LinkButton
            Icon={Spreadsheet}
            link="https://www.instagram.com"
            text="Planilha Comercial"
          />
          <LinkButton
            Icon={Spreadsheet}
            link="https://www.instagram.com"
            text="Planilha 3 dígitos"
          /> */}
        </div>
      </div>
    </div>
  );
};

export default LinksComponent;
